var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFirstAidKit = function SvgIconFirstAidKit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 10.875a1 1 0 1 0-2 0V12.5H9.375a1 1 0 1 0 0 2H11v1.625a1 1 0 1 0 2 0V14.5h1.625a1 1 0 1 0 0-2H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75 2.375a2.5 2.5 0 0 0-2.5 2.5v.875h-3.5A1.75 1.75 0 0 0 2 7.5v12c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 19.5v-12a1.75 1.75 0 0 0-1.75-1.75h-3.5v-.875a2.5 2.5 0 0 0-2.5-2.5zm5 3.375v-.875a.5.5 0 0 0-.5-.5h-4.5a.5.5 0 0 0-.5.5v.875zm5.25 2v11.5H4V7.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFirstAidKit;